export default {"src":"/sites/_next/static/media/icpsr-acronym-long-WHITE-CS6.9ef1b4b7.svg","height":47,"width":353,"blurWidth":0,"blurHeight":0};